var widgetConfig = {
  temp: {
    title: 'Outdoor',
    priority: 0.5,
    keywords: ['temperature', 'outdoor', 'humidity', 'dew', 'feels', 'eclipse'],
    share: {
      social: true,
      paths: [['currentDevice', 'lastData', 'tempf'], ['currentDevice', 'lastData', 'humidity'], ['currentDevice', 'lastData', 'dateutc'], ['user', 'info', 'settings', 'tempf'], ['device', 'yesterdayData']],
      component: 'TempWidget'
    }
  },
  tempkestrel: {
    title: 'Ambient',
    priority: 0.5,
    keywords: ['temperature'],
    share: {
      social: false,
      paths: [['currentDevice', 'lastData', 'tempf'], ['currentDevice', 'lastData', 'dateutc']],
      component: 'GenericWidget'
    }
  },
  wind: {
    title: 'Wind',
    priority: 1,
    keywords: ['wind', 'direction'],
    share: {
      social: true,
      paths: [['currentDevice', 'lastData', 'winddir'], ['currentDevice', 'lastData', 'windspeedmph'], ['user', 'info', 'settings', 'windspeedmph'], ['currentDevice', 'lastData', 'windgustmph']],
      component: 'WindWidget'
    }
  },
  rain: {
    title: 'Rainfall',
    priority: 2,
    keywords: ['rain'],
    share: {
      social: true,
      paths: [['currentDevice', 'lastData', 'hourlyrainin'], ['currentDevice', 'lastData', 'dailyrainin'], ['currentDevice', 'lastData', 'weeklyrainin'], ['currentDevice', 'lastData', 'monthlyrainin'], ['currentDevice', 'lastData', 'hourlyrainin'], ['user', 'info', 'settings', 'windspeedmph'], ['currentDevice', 'lastData', 'lastRain']],
      component: 'RainWidget'
    }
  },
  rain2: {
    title: 'Rainfall Calendar',
    priority: 2.5,
    keywords: ['rain', 'calendar', 'rainfall']
  },
  pressure: {
    title: 'Pressure',
    priority: 3,
    keywords: ['pressure', 'barometer', 'barometric'],
    share: {
      social: true,
      paths: [['currentDevice', 'lastData', 'humidity'], ['currentDevice', 'lastData', 'dateutc'], ['device', 'pressureWidgetLastHour']],
      component: 'PressureWidget'
    }
  },
  humidity: {
    title: 'Humidity',
    priority: 3.5,
    keywords: ['humidity', 'moisture'],
    share: {
      social: true,
      paths: [['currentDevice', 'lastData', 'humidity'], ['currentDevice', 'lastData', 'dateutc'], ['device', 'yesterdayData']],
      component: 'HumidityWidget'
    }
  },
  uv: {
    title: 'UV Index',
    priority: 5,
    keywords: ['uv', 'index', 'ultra', 'violet', 'sun', 'eclipse'],
    share: {
      social: true,
      paths: [['currentDevice', 'lastData', 'uv']],
      component: 'UvWidget'
    }
  },
  solar: {
    title: 'Solar Radiation',
    priority: 6,
    keywords: ['solar', 'sun', 'radiation', 'eclipse'],
    share: {
      social: true,
      paths: [['currentDevice', 'lastData', 'solarradiation'], ['user', 'info', 'settings', 'solarradiation'], ['currentDevice', 'lastData', 'hl', 'solarradiation', 'h']],
      component: 'SolarWidget'
    }
  },
  air: {
    title: 'PM2.5 Outdoor',
    priority: 6.5,
    keywords: ['air', 'particulate', 'matter', 'smog', 'pm2.5'],
    share: {
      social: true,
      paths: [['currentDevice', 'lastData', 'pm25'], ['currentDevice', 'lastData', 'pm25_24h']],
      component: 'AirWidget'
    }
  },
  lightning: {
    title: 'Lightning',
    priority: 6.55,
    keywords: ['lightning', 'strikes', 'thunder'],
    share: {
      social: true,
      paths: [],
      component: 'LightningWidget'
    }
  },
  indoor: {
    title: 'Indoor',
    priority: 6.6,
    keywords: ['temperature', 'indoor', 'humidity'],
    share: {
      social: true,
      paths: [['currentDevice', 'lastData', 'tempinf'], ['user', 'info', 'settings', 'tempf'], ['currentDevice', 'lastData', 'humidityin']],
      component: 'IndoorWidget'
    }
  },
  aqin: {
    title: 'Air Quality Index',
    priority: 6.65,
    keywords: ['air', 'indoor', 'particulate', 'matter', 'smog', 'pm2.5'],
    share: {
      social: true,
      paths: [['currentDevice', 'lastData', 'pm10_in_24h_aqin'], ['currentDevice', 'lastData', 'pm25_in_24h_aqin'], ['currentDevice', 'lastData', 'aqi_pm25_24h_aqin'], ['currentDevice', 'lastData', 'aqi_pm10_24h_aqin'], ['currentDevice', 'lastData', 'pm25_in_aqin'], ['currentDevice', 'lastData', 'pm10_in_aqin'], ['currentDevice', 'lastData', 'hl', 'pm10_in_aqin'], ['currentDevice', 'lastData', 'hl', 'pm25_in_aqin']]
    }
  },
  airin: {
    title: 'PM2.5 Indoor',
    priority: 6.7,
    keywords: ['air', 'indoor', 'particulate', 'matter', 'smog', 'pm2.5'],
    share: {
      social: true,
      paths: [['currentDevice', 'lastData', 'pm25_in'], ['currentDevice', 'lastData', 'pm25_in_24h']],
      component: 'AirWidget'
    }
  },
  co2: {
    title: 'Indoor Air Quality',
    priority: 6.75,
    keywords: ['air', 'indoor', 'particulate', 'matter', 'co2', 'carbon dioxide', 'parts per million'],
    share: {
      social: true,
      paths: [['currentDevice', 'lastData', 'co2_in_aqin'], ['currentDevice', 'lastData', 'pm_in_temp_aqin'], ['currentDevice', 'lastData', 'pm_in_humidity_aqin']]
    }
  },
  leak: {
    title: 'Leak Detector',
    priority: 6.8,
    keywords: ['leak', 'water'],
    fields: ['leak1', 'leak2', 'leak3', 'leak4']
  },
  sensors: {
    title: 'Sensors',
    priority: 7,
    keywords: ['sensors', 'temperature', 'humidity'],
    fields: ['temp1f', 'temp2f', 'temp3f', 'temp4f', 'temp5f', 'temp6f', 'temp7f', 'temp8f', 'temp9f', 'temp10f', 'humidity1', 'humidity2', 'humidity3', 'humidity4', 'humidity5', 'humidity6', 'humidity7', 'humidity8', 'humidity9', 'humidity10']
  },
  temp1f: {
    title: 'Sensor 1',
    priority: 7.01,
    keywords: ['sensor']
  },
  soiltemp1: {
    title: 'Soil 1',
    priority: 7.01,
    keywords: ['soil', 'sensor'],
    share: {
      social: true,
      component: 'SoilWidget'
    }
  },
  temp2f: {
    title: 'Sensor 2',
    priority: 7.02,
    keywords: ['sensor']
  },
  soiltemp2: {
    title: 'Soil 2',
    priority: 7.02,
    keywords: ['soil', 'sensor'],
    share: {
      social: true,
      paths: [],
      component: 'SoilWidget'
    }
  },
  temp3f: {
    title: 'Sensor 3',
    priority: 7.03,
    keywords: ['sensor']
  },
  soiltemp3: {
    title: 'Soil 3',
    priority: 7.03,
    keywords: ['soil', 'sensor']
  },
  temp4f: {
    title: 'Sensor 4',
    priority: 7.04,
    keywords: ['sensor']
  },
  soiltemp4: {
    title: 'Soil 4',
    priority: 7.04,
    keywords: ['soil', 'sensor']
  },
  temp5f: {
    title: 'Sensor 5',
    priority: 7.05,
    keywords: ['sensor']
  },
  soiltemp5: {
    title: 'Soil 5',
    priority: 7.05,
    keywords: ['soil', 'sensor']
  },
  temp6f: {
    title: 'Sensor 6',
    priority: 7.06,
    keywords: ['sensor']
  },
  soiltemp6: {
    title: 'Soil 6',
    priority: 7.06,
    keywords: ['soil', 'sensor']
  },
  temp7f: {
    title: 'Sensor 7',
    priority: 7.07,
    keywords: ['sensor']
  },
  soiltemp7: {
    title: 'Soil 7',
    priority: 7.07,
    keywords: ['soil', 'sensor']
  },
  temp8f: {
    title: 'Sensor 8',
    priority: 7.08,
    keywords: ['sensor']
  },
  soiltemp8: {
    title: 'Soil 8',
    priority: 7.08,
    keywords: ['soil', 'sensor']
  },
  temp9f: {
    title: 'Sensor 9',
    priority: 7.09,
    keywords: ['sensor']
  },
  soiltemp9: {
    title: 'Soil 9',
    priority: 7.09,
    keywords: ['soil', 'sensor']
  },
  temp10f: {
    title: 'Sensor 10',
    priority: 7.10,
    keywords: ['sensor']
  },
  soiltemp10: {
    title: 'Soil 10',
    priority: 7.10,
    keywords: ['soil', 'sensor'],
    share: {
      social: true,
      component: 'SoilWidget'
    }
  },
  soiltemp11: {
    title: 'Soil 11',
    priority: 7.101,
    keywords: ['soil', 'sensor'],
    share: {
      social: true,
      component: 'SoilWidget'
    }
  },
  soiltemp12: {
    title: 'Soil 12',
    priority: 7.102,
    keywords: ['soil', 'sensor'],
    share: {
      social: true,
      component: 'SoilWidget'
    }
  },
  soiltemp13: {
    title: 'Soil 13',
    priority: 7.103,
    keywords: ['soil', 'sensor'],
    share: {
      social: true,
      component: 'SoilWidget'
    }
  },
  soiltemp14: {
    title: 'Soil 14',
    priority: 7.104,
    keywords: ['soil', 'sensor'],
    share: {
      social: true,
      component: 'SoilWidget'
    }
  },
  soiltemp15: {
    title: 'Soil 10',
    priority: 7.105,
    keywords: ['soil', 'sensor'],
    share: {
      social: true,
      component: 'SoilWidget'
    }
  },
  soiltemp16: {
    title: 'Soil 16',
    priority: 7.106,
    keywords: ['soil', 'sensor'],
    share: {
      social: true,
      component: 'SoilWidget'
    }
  },
  soiltens1: {
    title: 'Soil Tension 1',
    priority: 7.50,
    keywords: ['soil', 'sensor']
  },
  soiltens2: {
    title: 'Soil Tension 2',
    priority: 7.51,
    keywords: ['soil', 'sensor']
  },
  soiltens3: {
    title: 'Soil Tension 3',
    priority: 7.52,
    keywords: ['soil', 'sensor']
  },
  soiltens4: {
    title: 'Soil Tension 4',
    priority: 7.53,
    keywords: ['soil', 'sensor']
  },
  leafwetday: {
    title: 'Leaf Wetness, Daily Sum',
    priority: 7.6,
    keywords: ['leaf', 'sensor']
  },
  leafwet1x: {
    title: 'Leaf Wetness',
    priority: 7.6,
    keywords: ['leaf', 'sensor']
  },
  leafwetness1: {
    title: 'Leaf Wetness 1',
    priority: 7.6,
    keywords: ['leaf', 'sensor']
  },
  leafwetness2: {
    title: 'Leaf Wetness 2',
    priority: 7.6,
    keywords: ['leaf', 'sensor']
  },
  leafwetness3: {
    title: 'Leaf Wetness 3',
    priority: 7.6,
    keywords: ['leaf', 'sensor']
  },
  leafwetness4: {
    title: 'Leaf Wetness 4',
    priority: 7.6,
    keywords: ['leaf', 'sensor']
  },
  leafwetness5: {
    title: 'Leaf Wetness 5',
    priority: 7.6,
    keywords: ['leaf', 'sensor']
  },
  leafwetness6: {
    title: 'Leaf Wetness 6',
    priority: 7.6,
    keywords: ['leaf', 'sensor']
  },
  leafwetness7: {
    title: 'Leaf Wetness 7',
    priority: 7.6,
    keywords: ['leaf', 'sensor']
  },
  leafwetness8: {
    title: 'Leaf Wetness 8',
    priority: 7.6,
    keywords: ['leaf', 'sensor']
  },
  gdd: {
    title: 'Growing Degree Days',
    priority: 7.71,
    keywords: ['growing', 'degree', 'days']
  },
  gdd2: {
    title: 'Growing Degree Days',
    priority: 7.71,
    keywords: ['growing', 'degree', 'days']
  },
  cdd: {
    title: 'Cooling Degree Days',
    priority: 7.71,
    keywords: ['cooling', 'heating', 'degree', 'days']
  },
  hdd: {
    title: 'Heating Degree Days',
    priority: 7.71,
    keywords: ['heating', 'degree', 'days']
  },
  // evapotranspiration: {
  // etos: {
  //   title: 'Evapotranspiration',
  //   priority: 7.72,
  //   keywords: [
  //     'evapotranspiration'
  //   ]
  // },
  etrs: {
    title: 'Evapotranspiration',
    priority: 7.73,
    keywords: ['evapotranspiration']
  },
  relays: {
    title: 'Relays',
    priority: 8,
    keywords: ['relays'],
    fields: ['relay1', 'relay2', 'relay3', 'relay4', 'relay5', 'relay6', 'relay7', 'relay8', 'relay9', 'relay10']
  },
  battery: {
    title: 'Batteries',
    priority: 8.5,
    keywords: ['battery', 'level'],
    fields: ['battout', 'battin', 'batt1', 'batt2', 'batt3', 'batt4', 'batt5', 'batt6', 'batt7', 'batt8', 'batt9', 'batt10', 'battr1', 'battr2', 'battr3', 'battr4', 'battr5', 'battr6', 'battr7', 'battr8', 'battr9', 'battr10', 'batt_25', 'batt_25in', 'batleak1', 'batleak2', 'batleak3', 'batleak4', 'batt_lightning']
  },
  batt1volts: {
    title: 'Battery Levels',
    priority: 12.1,
    keywords: ['battvolts']
  },
  forecast: {
    title: 'Forecast',
    priority: 8.51,
    keywords: ['five', 'day', 'forecast', 'seven', 'tomorrow', '5', '7', 'report'],
    share: {
      social: true
    }
  },
  map: {
    title: 'Map',
    priority: 8.52,
    keywords: ['map', 'location']
  },
  webcam: {
    title: 'Webcam',
    priority: 8.53,
    keywords: ['webcam', 'camera', 'live', 'picture']
  },
  sunMoon: {
    title: 'Sun / Moon',
    priority: 8.6,
    keywords: ['sun', 'moon', 'solar', 'lunar', 'sunrise', 'astronomy']
  },
  stats: {
    title: 'Dev stats',
    priority: 9,
    keywords: ['stats']
  },
  view: {
    title: 'Quick View',
    priority: 10,
    keywords: ['quick', 'view']
  },
  'wbgt-guideline': {
    title: "WBGT Guideline",
    priority: 0.1,
    keywords: ['flag', 'zone']
  },
  wbgt: {
    title: 'WBGT',
    priority: 11,
    keywords: ['wbgt']
  },
  heatindex: {
    title: 'Heat Index',
    priority: 12,
    keywords: ['heatindex']
  },
  pig: {
    title: 'PIG',
    priority: 11,
    keywords: ['pig']
  },
  crosswind: {
    title: 'Crosswind/Headwind',
    priority: 11
  },
  airdensity: {
    title: 'Air Density',
    priority: 11
  },
  dischargerate: {
    title: 'Discharge Rate',
    priority: 12,
    keywords: ['dischargerate'],
    share: {
      social: false,
      paths: [['currentDevice', 'lastData', 'dischargeft3s'], ['currentDevice', 'lastData', 'dateutc']],
      component: 'DischargeRateWidget'
    }
  },
  gaugeheight: {
    title: 'Gauge Height',
    priority: 12,
    keywords: ['gaugeheight'],
    share: {
      social: false,
      paths: [['currentDevice', 'lastData', 'gaugeheightft'], ['currentDevice', 'lastData', 'dateutc']],
      component: 'GaugeHeightWidget'
    }
  },
  waterph: {
    title: 'Water pH',
    priority: 12,
    keywords: ['waterph'],
    share: {
      social: false,
      paths: [['currentDevice', 'lastData', 'watermeasph'], ['currentDevice', 'lastData', 'dateutc']],
      component: 'WaterPhWidget'
    }
  },
  waternitrates: {
    title: 'Water Nitrates',
    priority: 12,
    keywords: ['waternitrates'],
    share: {
      social: false,
      paths: [['currentDevice', 'lastData', 'waternitratesmgl'], ['currentDevice', 'lastData', 'dateutc']],
      component: 'WaterNitratesWidget'
    }
  }
};
module.exports = {
  widgetConfig: widgetConfig
};